<template>
	<!-- 应用中心首页 -->
	<v-container fluid class="px-0" style="height: 100%">
		<div class="pb-3" style="width: 100%; height: 100%">
			<v-card class="shadow ma-3" style="height: 100%" elevation="0">
				<v-card-title>
					<v-btn @click="$router.push('/serv')" color="blue" icon><v-icon>mdi-arrow-left</v-icon></v-btn>
					应用中心 <v-spacer />
					<v-btn depressed class="white--text mr-3" color="cyan" @click="$router.push({ path: '/uams/apps-acid' })"><v-icon>mdi-power-plug</v-icon> 开发</v-btn>
					<v-btn depressed class="white--text" color="green" @click="add"><v-icon>mdi-plus</v-icon> 新建</v-btn>
				</v-card-title>
				<v-toolbar flat>
					<v-btn-toggle v-model="btnValue" @change="btnGroupClick" :color="btnValue | dict('1:blue/2:orange/3:green')" mandatory dense group class="ml-n2">
						<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index">{{ item.val }}</v-btn>
					</v-btn-toggle>
					<v-spacer></v-spacer>
					<div style="width: 300px">
						<v-text-field @click:append="search" @keyup.enter="search" v-model="queryParam.condition" placeholder="名称/简介" class="pt-5" append-icon="mdi-magnify" outlined dense clearable></v-text-field>
					</div>
				</v-toolbar>
				<v-card-text class="pt-0">
					<v-list flat>
						<v-list-item-group color="blue" active-class="app_nav">
							<v-row>
								<v-col v-for="(item, i) in desserts" :key="i" cols="12" md="3" sm="6">
									<v-list-item class="appItems rounded-lg pb-8 pl-0" three-line :to="`/uams/apps-view?aid=${item.id}`">
										<v-badge bottom overlap bordered offset-x="25" offset-y="30" :color="item.state == 1 ? 'green' : 'red'">
											<v-list-item-avatar color="blue-grey lighten-5" size="72" style="border-radius: 12px">
												<v-icon :color="item.type | dict('1:blue/2:orange/3:green')" size="36">{{ item.props }}</v-icon>
											</v-list-item-avatar>
										</v-badge>
										<v-list-item-content>
											<v-list-item-title class="title font-weight-regular mb-1">{{ item.name }}</v-list-item-title>
											<v-list-item-subtitle style="line-height: unset">{{ item.note }}</v-list-item-subtitle>
											<v-subheader class="sub_title grey--text caption">
												{{ item.leve | dict("0:国家/2:省级/4:市级/6:区县") }}<v-spacer />
												<div class="float-right">
													<v-icon v-if="item.turi && item.turi != '#'" size="16" class="ml-2" color="green" title="大屏端已适配">mdi-television</v-icon>
													<v-icon v-else size="16" class="ml-2" color="red" title="大屏端未适配">mdi-television-off</v-icon>
													<v-icon v-if="item.puri && item.puri != '#'" size="16" class="ml-2" color="green" title="电脑端已适配">mdi-laptop</v-icon>
													<v-icon v-else size="16" class="ml-2" color="red" title="电脑端未适配">mdi-laptop-off</v-icon>
													<v-icon v-if="item.muri && item.muri != '#'" size="16" class="ml-2" color="green" title="手机端已适配">mdi-cellphone</v-icon>
													<v-icon v-else size="16" class="ml-2" color="red" title="手机端未适配">mdi-cellphone-off</v-icon>
												</div>
											</v-subheader>
										</v-list-item-content>
									</v-list-item>
								</v-col>
							</v-row>
						</v-list-item-group>
					</v-list>
					<div v-if="desserts.length < 1" class="pr-1 pb-0 pt-1 text-center grey--text"><v-img class="mx-auto mb-4 mt-12" src="../../assets/img/noData.png" max-width="300px"></v-img>暂无应用信息</div>
					<pagination class="mt-4 mr-2 float-right" :page-sizes="[12, 12, 24]" :page-data="pageData" @pageChange="getListPage" />
				</v-card-text>
			</v-card>

			<!-- 应用新增表单 -->
			<v-dialog v-model="dialog" persistent max-width="527">
				<v-card>
					<v-card-title>
						新建应用<v-spacer />
						<v-btn class="mx-0" icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
					</v-card-title>
					<v-divider />
					<v-card-text class="pb-1">
						<!-- 应用预览 -->
						<v-list-item class="rounded mt-4 pa-3" style="border: 1px dashed #99999952">
							<v-list-item-avatar class="rounded" color="blue-grey lighten-5" size="56">
								<v-icon color="primary" size="40">{{ appsCreate.props || "mdi-microsoft-windows" }}</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="title font-weight-regular mb-1">{{ appsCreate.name || "应用的名称" }}</v-list-item-title>
								<v-list-item-subtitle style="line-height: unset">
									{{ appsCreate.note || "简介主要包括应用功能、用户群体、特色场景、注意事项等！" }}
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
						<v-form ref="appsCreate" v-model="appsValid" :model="appsCreate">
							<v-radio-group v-model="appsCreate.type" row dense mandatory :rules="[(v) => !!v || '服务平台不能为空']">
								<v-radio label="治理端应用" value="1"></v-radio>
								<v-radio label="服务端应用" value="2"></v-radio>
								<v-radio label="协同端应用" value="3"></v-radio>
							</v-radio-group>
							<vtk-area-tree v-model="appsCreate.area" :minLeve="4"/>
							<wtk-select v-model="appsCreate.auth" label="应用授权" :rules="[(v) => !!v || '应用授权不能为空!']" list="0:开放应用/1:授权应用" dense outlined></wtk-select>
							<v-text-field label="应用代码" placeholder="应用代码，建议使用开发代码工程名称" dense outlined v-model="appsCreate.code" :rules="[(v) => !!v || '应用代码不能为空']"></v-text-field>
							<v-text-field label="应用名称" placeholder="应用名称，建议使用4~8字简洁名称" dense outlined v-model="appsCreate.name" :rules="[(v) => !!v || '应用名称不能为空']"></v-text-field>
							<v-text-field label="应用图标" placeholder="应用图标，请查阅注意并从图标库中选择" dense outlined v-model="appsCreate.props" :rules="[(v) => !!v || '应用图标不能为空']">
								<template v-slot:append>
									<a target="_blank" href="https://pictogrammers.github.io/@mdi/font/5.9.55" style="margin-top: 3px">图标</a>
								</template>
							</v-text-field>
							<v-textarea label="应用描述" placeholder="应用描述，建议包含应用的功能、用户、场景、事项等" dense outlined v-model="appsCreate.note" :rules="[(v) => !!v || '应用描述不能为空']" auto-grow rows="3"></v-textarea>
						</v-form>
						<p>
							注意：<br />
							1. 应用的级别仅用于首页界面的展示，请根据实际情况填写；<br />
							2. 应用的名称请在8个字以内，以确保页面展示的整洁；<br />
							3. 应用的简介请用简洁文字描述应用的功能、用户、场景、事项等；<br />
							4. 应用的图标统一采用MDI字体，详细样式后续修改**<a target="_blank" href="https://pictogrammers.github.io/@mdi/font/5.9.55">图标</a>**；<br />
							5. 开放应用指登录应用皆可使用，授权应用需要申请资质后使用。
						</p>
					</v-card-text>
					<v-divider />
					<v-card-actions class="mx-auto">
						<v-spacer />
						<v-btn text @click="close"> 取消 </v-btn>
						<v-btn text @click="submit" color="primary"> 确定 </v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!-- ./应用新增表单 -->
		</div>
	</v-container>
</template>
<script>
import Message from "@/components/message";
import PageMixins from "@/compositions/mixins/pagination";
import Pagination from "@/components/pagination";
import Request from "@//commons/request";
import Storage from "@/commons/storage";
import wtkSelect from "@/components/dictionary/WtkSelect";

export default {
	mixins: [PageMixins],
	components: { Pagination, wtkSelect },
	data: () => ({
		url: { list: "/app/apps/page" },
		btnGroup: [
			{ key: "1", val: "治理端" },
			{ key: "2", val: "服务端" },
			{ key: "3", val: "协同端" },
		],
		btnValue: "1",
		acid: [],
		appsCreate: { icon: "" },
		appsValid: true,
		dialog: false,
		page: {
			pageno: 1,
			limit: 12,
		},
	}),
	activated() {
		this.user = Storage.get("_wit_acis_users");
		this.queryParam.type = this.btnValue;
		this.queryParam.bizAcid = this.user.uniCode;
		this.loadData();
	},
	methods: {
		//搜索
		search() {
			this.queryParam.type = this.btnValue;
			this.queryParam.bizAcid = this.user.uniCode;
			this.searchQuery();
		},
		//新增应用
		add() {
			this.appsCreate.type = this.btnValue;
			this.dialog = true;
		},
		btnGroupClick() {
			Message.loading.show();
			this.queryParam.type = this.btnValue;
			this.searchQuery();
		},
		submit() {
			console.log(this.appsCreate.area);
			if (this.$refs.appsCreate.validate()) {
				this.appsCreate.leve = this.appsCreate.area == "0" ? "0" : this.appsCreate.area.length;
				this.appsCreate.bizAcid = this.user.uniCode;
				this.appsCreate.bizCode = "Z0";
				this.appsCreate.operator = this.user.citizenName;
				Request.postJson("/app/apps/save", this.appsCreate).then((res) => {
					if (res.meta.success) {
						Message.toast("创建成功", { color: "success" });
						this.$router.push({ path: "/uams/apps-view", query: { aid: res.data.id } });
						this.close();
					} else {
						Message.toast("创建失败，请联系管理员", { color: "error" });
					}
				});
			}
		},
		close() {
			this.$refs.appsCreate.reset();
			this.dialog = false;
		},
	},
};
</script>
<style scoped>
.appItems {
	border: 1px solid #99999952;
}
.app_nav {
	border: 1px solid #1890ff;
	background: #34b1ff13 !important;
}
.sub_title {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
::v-deep .v-badge__badge {
	height: 12px;
	min-width: 10px;
}
</style>
